export const packageVersion: string = "18.52.3" as const;
